<div class="allRulesContainer">
  <div class="rulesContainer">
    <mat-form-field class="medium-field">
      <mat-label>Driving Field</mat-label>
      <mat-select matInput #drivingFieldSelection="ngModel"
        [(ngModel)]="drivingField"
        (selectionChange)="drivingFieldChange()"
        id="drivingFieldSelector">
        @for (field of drivingFields; track fieldTrackBy($index, field)) {
          <mat-option
            [value]="field">
            {{ field.FieldName | translate: 'Text' | async }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <button mat-button
      color="primary"
      (click)="manageListItems()">
      <mat-icon>list</mat-icon>
      <span>Manage List Items</span>
    </button>
    <button mat-button
      color="primary"
      (click)="filterColumns=!filterColumns">
      <mat-icon>filter_list</mat-icon><span>Filter Columns</span>
    </button>
    @if (filterColumns) {
      <div>
        @for (listValue of listValues; track listValueTrackBy($index, listValue)) {
          <mat-checkbox class="shown-list-value" [(ngModel)]="listValue.shown">{{listValue.Text}}</mat-checkbox>
        }
      </div>
    }
  </div>
  <div class="mainContent">
    <div>
      <div class="float-table">
        @for (fieldGroup of moduleService.fieldGroups; track groupTrackBy($index, fieldGroup)) {
          <div class="headers sticky">
            <div class="field-name">
              <span>{{fieldGroup.UiGroupName | translate: 'Text' | async}}</span>
            </div>
            @for (t of listValues | listItemTypeFilter; track listValueTrackBy($index, t); let yisOdd = $odd; let yisEven = $even) {
              <div class="list-values"
                [class.odd]="yisOdd"
                [class.even]="yisEven">
                <div class="rotate"><span [title]="t.Text">{{t.Text}}</span></div>
              </div>
            }
          </div>
          @for (field of moduleService.fields | fieldGroupFilter:[fieldGroup.UiGroupName, fieldFilter]; track fieldTrackBy($index, field); let sisOdd = $odd; let sisEven = $even) {
            <div class="rows">
              <div [class.field-odd]="sisOdd"
                [class.field-even]="sisEven" (click)="openFieldModalComponent(field)">
                <div>
                  <span>{{ field.FieldName | translate: 'Text' | async }}</span>
                  <br />
                  <span><em>{{field.FieldName}}</em></span>
                  @if (field.IsMandatory) {
                    <mat-icon class="field-icon" title="This field is always Mandatory, so can't have rules applied."></mat-icon>
                  }
                  @if (field.IsAlwaysHidden) {
                    <mat-icon class="field-icon" title="This field is always hidden, so can't have rules applied.">do_not_disturb</mat-icon>
                  }
                </div>
              </div>
              @for (t of listValues | listItemTypeFilter; track listValueTrackBy($index, t); let disOdd = $odd; let disEven = $even) {
                <div [class.odd]="disOdd"
                  [class.even]="disEven">
                  @if (fieldRulesEditable(field)) {
                    <span class="mod-col">
                      <button mat-mini-fab class="toggle visibility"
                        color="white"
                        (click)="toggleVisibilityRule(field,t)"
                        (contextmenu)="toggleHideRule(field,t)"
                        [disabled]="getMandatoryRuleState(field,t) || !moduleService.moduleContent.IsEditable"
                        [ngClass]="{'active': getVisibilityRuleState(field,t), 'hidden': getHideRuleState(field, t), 'default_off': hasAnyVisibilityRuleStates(field)}"
                        title="Toggle Visibility"
                        id="field-visibility-{{field.FieldId}}-{{t.Value}}">
                        <mat-icon aria-label="Toggle Visibility"></mat-icon>
                      </button>
                      <button mat-mini-fab class="toggle mandatory"
                        (click)="toggleMandatoryRule(field,t)"
                        [disabled]="((hasAnyHideRuleStates(field) && getHideRuleState(field, t)) || (!getVisibilityRuleState(field,t)) && !hasAnyHideRuleStates(field)) || !moduleService.moduleContent.IsEditable"
                        [ngClass]="{'active': getMandatoryRuleState(field,t)}"
                        title="Toggle Mandatory"
                        id="field-mandatory-{{field.FieldId}}-{{t.Value}}">
                        <mat-icon aria-label="Toggle Mandatory"></mat-icon>
                      </button>
                    </span>
                  }
                  @if (field.FieldId === drivingField.FieldId) {
                    <mat-icon title="This is the current driving field, so can't have rules applied based on itself.">clear</mat-icon>
                  }
                </div>
              }
            </div>
          }
        }
      </div>
    </div>
  </div>
</div>